import { SHOW_WARNING_NOTIFICATION, showNotification } from "Redux/Action";
import { Epic, ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import { of } from "rxjs";

export const showWarningNotificationEpic: Epic = ( action$ ) => {
    return action$.pipe(
        ofType( SHOW_WARNING_NOTIFICATION ),
        mergeMap((action) => of(showNotification({ notificationType: 'warning', message: action.payload.message })))
    )
}